module.exports = __webpack_public_path__ + "static/media/infoJumbo3.eb6f497d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/bodor/images/infoJumbo3.jpg
// module id = 581
// module chunks = 0